import {useNavigate} from "react-router";
import React, { useContext } from 'react';

import { BadgeTemplate } from "@/components/templates/";
import {Button, Label} from "@/components/atoms/";
import PrevIcon from '@/icons/prev-fat-icon.svg';
import { api } from '@/api/strapi';

import s from './home.module.scss';
import { InitialContext } from "../../app";

interface ConfirmPageProps {
    children?: React.ReactNode;
};

export const BadgeHomePage: React.FC<ConfirmPageProps> = (props) => {
    const navigate = useNavigate();
    const initialData = useContext(InitialContext) as { displayName: string };

    return (
        <BadgeTemplate className={s['confirm-page']}>
            <div className={s['confirm-page__text-container']}>
                <Label style={{
                    maxWidth: '25rem',
                    width: '100%',
                    whiteSpace: 'nowrap',
                }}>{initialData.displayName}</Label>
                <h4 style={{margin: '2rem 0'}}>Please confirm your name or Log out to change user</h4>
                <Button
                    onClick={async () => {
                        try {
                            const res = await api.badgeLogout();
                            window.location.href = res.json.sloUrl;
                        }
                        catch (e) {
                            console.error(e);
                        }
                    }}
                    style={{margin: '1rem auto'}}
                    variant={'secondary'}
                    start={<img src={PrevIcon} />}
                >
                    Log out
                </Button>
                <Button
                    onClick={async () => {
                        const response = await api.requestNameToBeShown();
                        navigate(`/badge/queue-info?waiting-time=${response?.waitingTime}`);
                    }}
                    style={{margin: '1rem auto'}}
                >
                    Display my name
                </Button>
            </div>
            {props.children}
        </BadgeTemplate>
    );
};
